import { log } from 'log';
import { useCallback } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { validateGeolocation } from 'js/hooks/auth/pas';

import { ReceivePacketCallback } from '../../../types';

import * as Types from '../types';

export const useRequestCafPacket = ({
    sdk,
    transactionID,
    onError,
    receivePacket,
    geolocationType
}: {
    sdk: Types.CAFSdkInstance | null;
    transactionID: string | null;
    onError: CallableFunction;
    receivePacket: ReceivePacketCallback;
    geolocationType: string;
}) => {
    return useCallback(async () => {
        if (!sdk || !sdk.Sdk) {
            return;
        }

        log('gcReq', {
            transactionID
        });

        const response = await validateGeolocation(null, null, null, null, null, geolocationType);
        const sessionValidationData = response.data.sessionValidationData || {};
        const sessionValidationByGeolocationData = sessionValidationData.SessionValidationByGeolocationData || [];
        const geolocationData = sessionValidationByGeolocationData[0] || {};
        const {
            identityJwt,
            trustJwt,
            policy,
            cpf,
            metadata
        } = Object.fromEntries(geolocationData.properties.map(({
            key,
            value
        }: {
            key: string;
            value: string;
        }) => {
            return [key, value];
        }));

        const cafSdk = new sdk.Sdk(
            identityJwt,
            {
                mobileToken: trustJwt,
                throwOnRecall: false,
                faceLivenessSettings: {
                    startButton: {},
                    permissionButton: {}
                },
                enableTimer: true,
                metadata
            });

        try {
            const verificationResult = await cafSdk.verifyPolicy(cpf, policy);

            log('gcInfo', {
                transactionID,
                license: {
                    identityJwt,
                    trustJwt,
                    policy,
                    cpf,
                    metadata
                },
                message: verificationResult.isAuthorized
            });

            receivePacket(JSON.stringify(verificationResult), transactionID);
        } catch (error) {
            publicEventsAPIService.trigger('geofencing-error', { error });

            onError(null, error);
        }
    }, [
        sdk,
        transactionID,
        onError,
        receivePacket,
        geolocationType
    ]);
};
